import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(edit) {
	return class extends GridCell {
		render() {
			return (
				<td>
					<button
						className="admin-k-button "
						onClick={() => {
							edit(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
					</button>
				</td>
			);
		}
	};
}
